import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" {...this.props}><path fill="none" stroke="#5D615F" strokeMiterlimit="10" d="M29.354 19.9V2m0 32.395V27.36M17.676 8.634V2m0 32.395v-18.32M6 19.085V2m0 32.395v-8.06" /><path fill="#EBEEEF" stroke="#5D615F" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M14 9h7.25v7.25H14z" /><path fill="none" stroke="#5D615F" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M25.73 20.013h7.25v7.25h-7.25zm-23.355-.94h7.25v7.25h-7.25z" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/assets/icons/filters.svg